// extracted by mini-css-extract-plugin
export default {"search":"AppSearchBar_search__zf1jN","searchIcon":"AppSearchBar_searchIcon__FaG--","inputRoot":"AppSearchBar_inputRoot__u8orh","inputInput":"AppSearchBar_inputInput__J0s4A"};